<app-login-header></app-login-header>
<nes-container data-pw="activate-account">
  <div @fadeIn class="nes-flex-col nes-pt-6 md:nes-pt-10">
    <nes-link
      class="nes-mb-8"
      data-pw="activate-account__back-link"
      icon="arrow-left"
      tabindex="-1"
      stand-alone
      (click)="backToOverview()"
      relay42
    >
      {{ 'LOGIN.BACK_TO_OVERVIEW' | translate }}
    </nes-link>

    <nes-heading class="nes-mb-8" [size]="'6xl'"> {{ 'LOGIN.REQUEST_ACCOUNT.TITLE' | translate }} </nes-heading>

    <nes-text class="nes-text-base nes-mb-8 nes-w-full md:nes-w-6/12">
        {{ ((accountType$ | async) === "contactpersoon" ? 'LOGIN.CHOOSE_ACCOUNT.NO_ACCOUNT_CP_TEXT' : 'LOGIN.REQUEST_ACCOUNT.SUBTITLE') | translate }}
    </nes-text>

    <form class="nes-flex-col nes-w-full" [formGroup]="emailForm$">
      <nes-input
        #activateAccountInput
        class="nes-mb-8 nes-w-full lg:nes-w-5/12"
        data-pw="activate-account__email"
        nesId="email"
        name="email"
        formControlName="email"
        auto-focus="true"
        max-width="auto"
        type="email"
        required="true"
        [label]="'LOGIN.REQUEST_ACCOUNT.EMAIL' | translate"
        [error]="this.emailErrorMessage | async"
        (nesOnKeyDown)="onKeyDown(emailForm$, $event)"
        (nesOnBlur)="checkEmail(emailForm$)"
        ngDefaultControl
      >
      </nes-input>
      <div class="nes-flex-col nes-mb-8">
        <nes-button
          data-pw="send-button-activate-account"
          width-auto="true"
          variant="primary"
          type="submit"
          (nesOnClick)="activateAccount(emailForm$)"
          [loading]="loading$ | async"
        >
          <p class="nes-bold nes-text-base">{{ 'LOGIN.SEND' | translate }}</p>
        </nes-button>
      </div>
    </form>

    <mnz-customer-requirements></mnz-customer-requirements>
  </div>
</nes-container>
